module.exports = __webpack_public_path__ + "static/logo-full-bbb80994eb72d86f16d2153c82fe4178.png";